import Crud from "../crud"
import { ADD, DELETE, FETCH } from "@/store/action-types"
import ApiService from "@/utils/api.service"
import {
  ADD_MUT,
  DELETE_MUT,
  SET_MUT,
  UPDATE_MUT,
} from "@/store/mutation-types"
import has from "lodash/has"
var crud = new Crud("users/pcr")

const state = {
  ...crud.state,
}
const getters = {
  ...crud.getters,
}
const actions = {
  [ADD]: ({ commit, state }, item) => {
    return new Promise((resolve, reject) => {
      let coach_id = item.coach.id
      delete item["coach"]
      item["pef_id"] = item.pef.id
      delete item["pef"]
      let edit = item.edit
      ApiService.post(`/${state.endpoint}/coaches/${coach_id}`, item)
        .then(({ data }) => {
          if (edit) {
            commit(UPDATE_MUT, data)
          } else {
            commit(ADD_MUT, data)
          }
          resolve(data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  [FETCH]: ({ commit, state }, req = {}) => {
    const { cancelToken, ...params } = req
    return new Promise((resolve, reject) => {
      delete params["user_id"]
      ApiService.query(`/${state.endpoint}`, { params, cancelToken })
        .then((res) => {
          if (typeof res !== typeof undefined) {
            const { data, headers } = res
            commit(SET_MUT, data)
            if (has(headers, "x-total-count")) {
              commit("SET_TOTAL_COUNT", Number(headers["x-total-count"]))
              resolve({ data, headers })
            } else {
              resolve(data)
            }
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  [DELETE]: ({ commit, state }, data) => {
    let coach_id = data.coach_id
    delete data["coach_id"]

    return new Promise((resolve, reject) => {
      return ApiService.delete(`/${state.endpoint}/coaches/${coach_id}`, {
        data,
      })
        .then(() => {
          commit(DELETE_MUT, data.id)
          resolve()
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
}
const mutations = {
  ...crud.mutations,
  [UPDATE_MUT]: (state, info) => {
    const index = state.data.findIndex(
      (item) => item.coach.id === info.coach.id && item.pef.id === info.pef.id
    )
    state.data.splice(index, 1, info)
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
